export default {
  white: "#ffffff",
  gray: "#f8f8f8",
  grayMedium: "#cccccc",
  grayRegular: "#e5e5e5",
  grayDark: "#999999",
  graySemibold: "#666666",
  grayBold: "#333333",
  black: "#000000",
  black30: "#c2c2c2",
  purpleLight: "#e2d2ff",
  purpleRegular: "#6e1fff",
  redRegular: "#FFEFED",
  redMedium: "#f7625a",
  redBold: "#F1170D",
  yellowRegular: "#FEF7E8",
  yellowMedium: "#fce1a8",
  yellowBold: "#f1af1b",
  greenRegular: "#0eda83",
  greenBold: "#0aa462",
}
